import React, { ReactElement } from "react";
import FullscreenClose from "../icon/fullscreen-close.svg";
import RightArrow from "../icon/arrow-right.svg";
import LeftArrow from "../icon/arrow-left.svg";

export function LeftRightArrows({
  displayIdx,
  setDisplayIdx,
  maxLength,
}: {
  displayIdx: number | null;
  setDisplayIdx: (i: number | null) => void;
  maxLength: number;
}): ReactElement {
  return (
    <div className="pb-4">
      <button
        className="hover:opacity-50"
        disabled={displayIdx == 0}
        onClick={() => setDisplayIdx(displayIdx - 1)}
      >
        <LeftArrow className="fill-none w-6 h-6 mr-2 mt-1" />
      </button>
      <button
        className="hover:opacity-50"
        disabled={displayIdx == maxLength}
        onClick={() => setDisplayIdx(displayIdx + 1)}
      >
        <RightArrow className="fill-none w-6 h-6 mr-4 mt-1" />
      </button>
    </div>
  );
}

export function CloseFullscreenModal({
  setShowModal,
}: {
  setShowModal: (i: number | null) => void;
}): ReactElement {
  return (
    <div className="flex justify-end">
      <button
        className="p-4 hover:opacity-50"
        onClick={() => setShowModal(null)}
      >
        <FullscreenClose />
      </button>
    </div>
  );
}
